import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import isPropValid from '@emotion/is-prop-valid';
import { useToggle } from '@infl-ts/util-hooks';
import { createChallengePlayerLink, useChallengePlayer } from '@infl-ts/util-use-challenge-player';
import { Box, Button, css, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, styled, Typography } from '@mui/material';
import { oneLine } from 'common-tags';
import { format, parseISO } from 'date-fns';
import * as A from 'fp-ts/Array';
import { constNull, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ProgressBar } from '../progress-bar';
import { RouterLink } from '../router-link';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var ActivityCard = styled(Box, {
  shouldForwardProp: isPropValid
})(function (_ref) {
  var isSelected = _ref.isSelected,
      theme = _ref.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", ";\n    border-left: ", ";\n    background: ", ";\n\n    &:hover #delete-btn {\n      display: inherit;\n    }\n  "])), theme.spacing(2), isSelected ? "".concat(theme.spacing(0.5), " ").concat(theme.palette.primary.main, " solid") : 'none', isSelected ? theme.palette.primary.background : 'inherit');
});

var InProgressActivityCard = function InProgressActivityCard(_ref2) {
  var activity = _ref2.activity,
      challenge = _ref2.challenge,
      closeDrawer = _ref2.closeDrawer,
      isSelected = _ref2.isSelected;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      confirmationOpen = _useToggle2[0],
      setClosed = _useToggle2[1].off;

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var _useChallengePlayer = useChallengePlayer(),
      challengeConfig = _useChallengePlayer.challengePlayerState.challengeConfig;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var currentStageIndex = activity.currentStage ? activity.currentStage.position + 1 : challenge.totalStages;
  return pipe(activity.timeline, O.fromNullable, O.map(A.filterMap(function (_ref3) {
    var createdAt = _ref3.createdAt;
    return O.fromNullable(createdAt);
  })), O.chain(A.last), O.map(function (lastActivityTime) {
    return lastActivityTime ? format(parseISO(lastActivityTime), 'E, MMM d, yyyy').toString() : 'n/a';
  }), O.getOrElseW(constNull), function (lastActivityTime) {
    return /*#__PURE__*/_jsxs(Box, {
      children: [/*#__PURE__*/_jsxs(ActivityCard, {
        isSelected: isSelected,
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            mb: 2,
            width: 1,
            display: 'flex',
            position: 'relative',
            justifyContent: 'space-between'
          },
          children: [lastActivityTime && /*#__PURE__*/_jsxs(Typography, {
            sx: {
              fontWeight: function fontWeight(t) {
                return t.typography.fontWeightBold;
              }
            },
            variant: "caption",
            children: [t('Last activity:'), " ", lastActivityTime]
          }), /*#__PURE__*/_jsxs(Dialog, {
            open: confirmationOpen,
            onClose: setClosed,
            PaperProps: {
              sx: {
                width: 1,
                maxWidth: 420
              }
            },
            children: [/*#__PURE__*/_jsx(DialogTitle, {
              sx: {
                fontSize: function fontSize(t) {
                  return t.typography.h3.fontSize;
                },
                fontWeight: function fontWeight(t) {
                  return t.typography.fontWeightRegular;
                }
              },
              children: t('Are you sure?')
            }), /*#__PURE__*/_jsx(DialogContent, {
              children: /*#__PURE__*/_jsx(DialogContentText, {
                children: t(oneLine(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                      Are you sure you want to delete this in-progress submission\n                      {{lastActivityTime}}? This action cannot be undone."]))), {
                  lastActivityTime: lastActivityTime ? " from ".concat(lastActivityTime) : ''
                })
              })
            }), /*#__PURE__*/_jsxs(DialogActions, {
              children: [/*#__PURE__*/_jsx(Button, {
                variant: "text",
                onClick: setClosed,
                children: t('Cancel')
              }), /*#__PURE__*/_jsx(Button, {
                variant: "contained",
                children: t('Delete submission')
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx(ProgressBar, {
          progress: (currentStageIndex - 1) / challenge.totalStages * 100
        }), /*#__PURE__*/_jsxs(Box, {
          sx: {
            mt: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          },
          children: [/*#__PURE__*/_jsxs(Typography, {
            sx: {
              fontWeight: function fontWeight(t) {
                return t.typography.fontWeightBold;
              }
            },
            variant: "caption",
            children: [t('Stage:'), " ", currentStageIndex, " / ", challenge.totalStages]
          }), challenge.availableForCompletion && !isSelected ? /*#__PURE__*/_jsx(Button, {
            component: RouterLink,
            size: "small",
            variant: "text",
            to: createChallengePlayerLink(pathname, _objectSpread(_objectSpread({}, challengeConfig !== null && challengeConfig !== void 0 ? challengeConfig : {
              uuid: challenge.id
            }), {}, {
              activity: activity.id
            })),
            onClick: closeDrawer,
            children: t('Continue')
          }) : null]
        })]
      }), /*#__PURE__*/_jsx(Divider, {})]
    });
  });
};

export default InProgressActivityCard;